import { MassMessagingStatusEnum, MassMessaging } from 'src/app/marketing/shared';

export class RunningMassMessagingVolumesRefresher {
  REFRESH_DELAY_MS = 60000;
  company;
  massMessagingList: MassMessaging[];
  MassMessagingFactory;
  isRunning: boolean;
  nextAutoRefreshPromise: any;
  constructor(company, massMessagingList: MassMessaging[], MassMessagingFactory) {
    this.company = company;
    this.massMessagingList = massMessagingList;
    this.MassMessagingFactory = MassMessagingFactory;
  }

  restartRefreshIfNeeded() {
    // one of the campaign status changed, it might means a campaign is now running, in that case refresher should be
    // started if it is not running
    if (!this.isRunning) {
      this.refreshVolumesOfRunningCampaign();
    }
  }

  refreshVolumesOfCreatedAndRunningCampaign() {
    // first refresh will refresh status of created and running campaigns.
    const massMessagingList = this.massMessagingList.filter(({ status }) =>
      [
        MassMessagingStatusEnum.STARTED_STATUS,
        MassMessagingStatusEnum.CREATED_STATUS,
        MassMessagingStatusEnum.WAITING_FOR_QUOTA,
      ].includes(status)
    );
    this.refreshVolumesOfCampaignList(massMessagingList);
  }

  refreshVolumesOfRunningCampaign() {
    // after one schedule, no need to refresh status of created campaign as figures won't change
    const massMessagingList = this.massMessagingList.filter(
      (massMessaging: MassMessaging) => massMessaging.status === MassMessagingStatusEnum.STARTED_STATUS
    );
    this.refreshVolumesOfCampaignList(massMessagingList);
  }

  private refreshVolumesOfCampaignList(massMessagingList: MassMessaging[]) {
    if (massMessagingList.length > 0) {
      this.isRunning = true;
      this.refreshVolumesOfCampaignListOneByOne(massMessagingList, 0);
    } else {
      // If there's no campaign to update, we won't refresh data and schedule next refresh.
      // It will be needed to call restartRefreshIfNeeded if status of a campaign changed
      this.isRunning = false;
    }
  }

  private refreshVolumesOfCampaignListOneByOne(massMessagingList: MassMessaging[], index) {
    if (index < massMessagingList.length) {
      const massMessaging: MassMessaging = massMessagingList[index];
      this.MassMessagingFactory.getMassMessagingVolumes(this.company.id, massMessaging) // Fetch campaign volumes
        .then(response => {
          this.MassMessagingFactory.setUIVolumeFieldsFromRawData(massMessaging, response.data);
          if (massMessaging.remainingNumberOfMessagesToSend === 0) {
            massMessaging.status = MassMessagingStatusEnum.COMPLETED_STATUS;
          }
          this.refreshVolumesOfCampaignListOneByOne(massMessagingList, +index + 1);
        });
    } else {
      this.nextAutoRefreshPromise = setTimeout(() => this.refreshVolumesOfRunningCampaign(), this.REFRESH_DELAY_MS);
    }
  }

  cancelNextAutoRefreshIfAny() {
    if (this.nextAutoRefreshPromise) {
      clearTimeout(this.nextAutoRefreshPromise);
    }
  }
}
